<template>
    <div class="row">
        <div class="col-12">
            <div class="card" v-if="notificationsSupported">
                <div class="card-header">
                    <b-form-checkbox
                        @change="subActions"
                        v-model="currentSubCheck"
                        switch
                    >{{ $t('Subscribe Push Notification') }}
                    </b-form-checkbox>
                </div>
            </div>

            <div class="card card-inactive" v-if="!isDataLoading && subscriptions.length==0">
                <div class="card-body text-center text-muted small">
                    <div class="row justify-content-center">
                        <div class="col-12 mt-5">
                            <div class="d-flex justify-content-center">
                                <img
                                    src="@/assets/img/illustrations/32desk/holding-phone.svg"
                                    class="img-fluid mt-n5"
                                    style="max-height: 400px;"
                                />
                            </div>
                            <p class="text-muted">{{ $t('No subscription yet') }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card" data-toggle="lists" v-else>
                <div class="card-body" v-if="isDataLoading">
                    <div class="row align-items-center active">
                        <div class="spinner-border text-primary" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>

                <div class="card-body" v-if="subscriptions.length !== 0">
                    <ul class="list-group list-group-sm list-group-flush list my-n4">
                        <li
                            class="list-group-item px-0"
                            v-for="(subscription, index) in subscriptions"
                            :key="index"
                        >
                            <div class="row">
                                <div class="col">
                                    <h4 class="mb-1" v-if="subscription.userAgent.browser">
                                        {{
                                            subscription.userAgent.browser.name + ' ' +
                                            subscription.userAgent.browser.major
                                        }}
                                        <span
                                            class="text-muted small"
                                            v-if="subscription.userAgent.os"
                                        >{{ ' ( ' + subscription.userAgent.os.name + ' ' + subscription.userAgent.os.version + ' )' }}</span>
                                    </h4>
                                    <span
                                        class="text-muted small"
                                    >{{ subscription.createdAt | moment("DD.MM.YYYY H:MM") }}</span>
                                    <p
                                        class="small mb-0"
                                        style="color: green"
                                        v-if="subscription._id === currentSub._id"
                                    >{{ $t('Current subscription') }}</p>
                                </div>

                                <div class="col-auto" v-if="subscription._id !== currentSub._id">
                                    <button
                                        @click="openModal({id:'confirmationModal', model: subscription })"
                                        class="btn btn-white btn-sm"
                                    >
                                        <i class="fe fe-trash-2" style="font-size: 17px"></i>
                                    </button>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <confirmation-modal id="confirmationModal" :item="model" :confirmAction="deleteItem"></confirmation-modal>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import ConfirmationModal from "@/components/ConfirmationModal.vue";
import {modalMixins} from "@/mixins/modal.js";
import permissions from "../../plugins/permissions";

const parser = require("ua-parser-js");

export default {
    name: "subscriptionList",
    mixins: [modalMixins],
    components: {
        ConfirmationModal
    },
    data() {
        return {
            params: {
                query: {
                    $limit: 1000,
                    $sort: {
                        createdAt: -1
                    }
                }
            },
            notificationsSupported: false,
            currentSubCheck: false,
            currentSub: {},
            serviceWorkerRegistation: null,
            subscription: null,
            userId: null
        };
    },
    mounted() {
        this.findSubscription().then(sub => {
            if (sub !== null) {
                this.subscription = sub;
                this.find({
                    query: {
                        subscription: sub
                    }
                }).then(res => {
                    if (res.data.length > 0) {
                        this.currentSub = res.data[0];
                        this.currentSubCheck = true;
                    }
                });
            }
        });
    },
    created() {
        this.userId = this.user._id;
        if ("Notification" in window && "serviceWorker" in navigator) {
            navigator.serviceWorker.ready.then(res => {
                this.notificationsSupported = true;
            });
        }
        this.fetchSubscriptions();
    },
    computed: {
        ...mapState("auth", ["user"]),
        ...mapState("subscriptions", {isDataLoading: "isFindPending"}),
        ...mapGetters("subscriptions", {findDataInStore: "find"}),
        subscriptions() {
            return this.findDataInStore({query: {userId: this.userId}}).data;
        }
    },
    methods: {
        ...mapActions("subscriptions", ["find", "remove", "patch", "create"]),
        fetchSubscriptions() {
            let params = {
                query: {
                    $limit: 1000,
                    $sort: {
                        createdAt: -1
                    },
                    userId: this.userId
                }
            };
            this.find(params);
        },

        deleteItem() {
            this.remove(this.model._id).then(result => {
                this.$toasted.global.success({
                    message: "Subscription has been deleted"
                });
            });
        },

        subActions(checked) {
            if (checked === true && this.currentSub !== null) {
                this.triggerSubscription();
            } else if (checked === false) {
                //this.subscription.unsubscribe().then( () => {
                this.remove(this.currentSub._id).then(result => {
                    this.$toasted.global.success({
                        message: "Subscription has been deleted"
                    });
                });
                /* }).catch(function(e) {
                            console.log(e)
                        }) */
            }
        },

        triggerSubscription() {
            if (this.notificationsSupported) {
                // Ask permission and when granted, create new subscription
                Notification.requestPermission().then(result => {
                    // if granted, create new subscription
                    if (result === "granted") {
                        this.createSubscription().then(sub => {
                            console.log(
                                "subscription created on the client",
                                JSON.stringify(sub)
                            );
                            this.subscription = sub;
                            return this.create({
                                subscription: sub,
                                userAgent: parser(navigator.userAgent)
                            }).then(newSub => {
                                this.currentSub = newSub;
                                this.$toasted.global.success({
                                    message: "Subscription has been created"
                                });
                            });
                        });
                    } else {
                        console.log("User did not granted permission");
                        this.currentSubCheck = false;
                        this.$toasted.show("Permission blocked please manually approve!", {
                            type: "error",
                            position: "top-center",
                            duration: 3000
                        });
                    }
                });
            }
        },
        createSubscription() {
            //console.log('ask for active service worker registration');
            if (this.serviceWorkerRegistation === null) {
                return navigator.serviceWorker.ready // returns a Promise, the active SW registration
                    .then(swreg => {
                        this.serviceWorkerRegistation = swreg;
                        return this.subscribe(this.serviceWorkerRegistation);
                    });
            } else {
                return this.subscribe(this.serviceWorkerRegistation);
            }
        },
        getSubscription(swreg) {
            //console.log('ask for available subscription');
            return swreg.pushManager.getSubscription();
        },
        subscribe(swreg) {
            //console.log('create new subscription for this browser on this device');
            // create new subscription for this browser on this device
            const vapidPublicKey =
                "BC0qfvcZ50vx6z2fWMxH8LhmuT9rybUYE_aXwqW-0qFnEdyzCq4b6HE5unWygKW7qFfR-dB4xl37G7jwR-eH1kM";
            const convertedVapidPublicKey = this.urlBase64ToUint8Array(
                vapidPublicKey
            );
            // return the subscription promise, we chain another then where we can send it to the server
            return swreg.pushManager.subscribe({
                userVisibleOnly: true,
                // This is for security. On the backend, we need to do something with the VAPID_PRIVATE_KEY
                // that you can find in .env to make this work in the end
                applicationServerKey: convertedVapidPublicKey
            });
        },
        findSubscription() {
            //console.log('get active service worker registration');
            return navigator.serviceWorker.ready.then(swreg => {
                //console.log('active subscription found');
                this.serviceWorkerRegistation = swreg;
                return this.getSubscription(this.serviceWorkerRegistation);
            });
        },
        urlBase64ToUint8Array(base64String) {
            const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
            const base64 = (base64String + padding)
                .replace(/\-/g, "+")
                .replace(/_/g, "/");

            const rawData = window.atob(base64);
            let outputArray = new Uint8Array(rawData.length);

            for (let i = 0; i < rawData.length; ++i) {
                outputArray[i] = rawData.charCodeAt(i);
            }
            return outputArray;
        }
    }
};
</script>
